import { IPreparationTimeForm } from '@/components-latest/ui/AccountPage/PreparationTimeForm'

export const validateMinMax = (values: IPreparationTimeForm) => {
  return (
    values.min !== null &&
    values.max !== null &&
    values.min < values.max &&
    values.max - values.min >= 5
  )
}

export const mapInitPreparationToForm = (initData: IPreparationTimeForm) => {
  return {
    min: initData?.min ? initData.min / 60000 : null,
    max: initData?.max ? initData.max / 60000 : null
  }
}
